/**
 * Cart page helpers (DTC).
 * Persists discount codes into checkout via ?discount=CODE.
 * Loaded only for non-B2B carts from main-cart-footer.liquid.
 */
(function () {
  if (window.__ptpCartDiscountCheckoutBound) return;
  window.__ptpCartDiscountCheckoutBound = true;

  function initDiscountCheckoutHandoff() {
    var cartForm =
      document.getElementById('cart') || document.getElementById('b2b-native-cart-form');
    var checkoutBtn = document.querySelector(
      '.cart__footer-buttons [name="checkout"], #checkout'
    );

    var discountInput = document.querySelector(
      '[name="discount"], #CartDiscount, .cart__discount-input, input[name="discount"]'
    );

    if (!cartForm || !checkoutBtn) return;

    checkoutBtn.addEventListener('click', function (e) {
      // Re-query in case an app injected the field after load
      discountInput = document.querySelector(
        '[name="discount"], #CartDiscount, .cart__discount-input, input[name="discount"]'
      );

      var code = discountInput && discountInput.value ? discountInput.value.trim() : '';

      if (!code) return;

      e.preventDefault();
      e.stopPropagation();

      // Shopify checkout discount deep-link
      window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      // After Corso / app scripts that may inject discount fields
      setTimeout(initDiscountCheckoutHandoff, 500);
    });
  } else {
    setTimeout(initDiscountCheckoutHandoff, 500);
  }
})();
